import React, { useState } from 'react';
import { Icon } from '@iconify/react';
import { Box, IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';

function MenuCardButton({ itemId, functionList }) {
  // menu
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClickMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  // ------------
  return (
    <>
      {functionList.length ? (
        <Box>
          <IconButton
            color="error"
            size="small"
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClickMenu}
          >
            <Icon icon="eva:more-vertical-fill" />
          </IconButton>

          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleCloseMenu}
            MenuListProps={{
              'aria-labelledby': 'basic-button'
            }}
          >
            {functionList.map((func) => (
              <MenuItem key={func.id} onClick={() => func.action(itemId)}>
                {func.icon && <ListItemIcon>{func.icon}</ListItemIcon>}
                <ListItemText>{func.label}</ListItemText>
              </MenuItem>
            ))}
          </Menu>
        </Box>
      ) : null}
    </>
  );
}

export default MenuCardButton;
